<div *ngIf="debate">
  <h1 class="h1 margin-bottom">{{ 'nouns.debate' | translate }}</h1>

  <div *ngIf="computedDebateData" class="row">
    <!-- Dashboard chips  -->
    <div class="col s2">
      <div class="dashboard-card-item widget-height">
        <div class="dashboard-card-item-title text-centered">{{ 'debates.widgets.duration' | translate }}</div>
        <div class="dashboard-card-item-text text-centered">{{ computedDebateData.numSessions }}</div>
        <div class="dashboard-card-item-label">{{ 'debates.widgets.seasons' | translate }}</div>
      </div>
    </div>

    <div class="col s3">
      <div class="dashboard-card-item widget-height">
        <div class="dashboard-card-item-title text-centered">{{ 'debates.widgets.votes' | translate }}</div>
        <div class="row">
          <div class="col s6">
            <div class="dashboard-card-item-text text-centered">
              <span> <i class="glicon-thumb-up font-20"></i> {{ computedDebateData.positiveVotePercentage }} % </span>
            </div>
            <div class="dashboard-card-item-label">{{ 'debates.widgets.positiveVotes' | translate }}</div>
          </div>
          <div class="col s6">
            <div class="dashboard-card-item-text text-centered">
              <span [ngClass]="{ 'red-color': computedDebateData.isHotDebate }">
                <i class="glicon-thumb-down font-20"></i>{{ computedDebateData.negativeVotePercentage }} %
              </span>
            </div>
            <div class="dashboard-card-item-label" [ngClass]="computedDebateData.isHotDebate ? 'red-color' : ''">
              {{ 'debates.widgets.negativeVotes' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col s3">
      <div class="dashboard-card-item widget-height">
        <div class="dashboard-card-item-title text-centered">{{ 'debates.widgets.opinions' | translate }}</div>
        <div class="dashboard-card-item-text text-centered">{{ computedDebateData.numOpinions }}</div>
      </div>
    </div>

    <div class="col s4">
      <div class="dashboard-card-item widget-height">
        <div class="dashboard-card-item-title text-centered">{{ 'debates.widgets.status' | translate }}</div>
        <div class="dashboard-card-item-text text-centered">
          {{ computedDebateData.debateStatusLabel | translate }}
          (<span
            [ngClass]="{
              'green-text': computedDebateData.groupQuestionStatus === 'CERTIFIED',
              'error-text': computedDebateData.groupQuestionStatus === 'CANCELLED'
            }"
          >
            {{ computedDebateData.groupQuestionStatusLabel | translate }} </span
          >)
        </div>
        <div class="row">
          <div class="col s6 center" *ngIf="!computedDebateData.debateIsErased">
            <gl-button
              color-secondary
              class="margin-top-half"
              [ngClass]="{ 'green-text': computedDebateData.groupQuestionStatus === 'CERTIFIED' }"
              icon-left="glicon-circle-check"
              [text]="'debates.widgets.certify' | translate"
              [disabled]="computedDebateData.debateIsClosed"
              (onClick)="onCertifyDebateQuestion()"
            >
            </gl-button>
          </div>
          <div class="col s6 center" *ngIf="!computedDebateData.debateIsErased">
            <gl-button
              color-secondary
              class="margin-top-half"
              [ngClass]="{ 'error-text': computedDebateData.groupQuestionStatus === 'CERTIFIED' }"
              icon-left="glicon-close"
              [text]="'debates.widgets.cancel' | translate"
              [disabled]="computedDebateData.debateIsClosed"
              (onClick)="onCancelDebateQuestion()"
            >
            </gl-button>
          </div>
          <!-- <div class="col s12" *ngIf="computedDebateData.debateIsErased">
            <gl-button
              color-secondary
              icon-left="glicon-refresh"
              class="margin-top-half"
              [text]="'debates.widgets.restore' | translate"
            >
            </gl-button>
          </div> -->
        </div>
      </div>
    </div>
  </div>

  <div class="row" id="opinions">
    <div *ngIf="questionInfo && questionInfo.choices != undefined">
      <ul class="list table-row">
        <li class="heading">{{ debate.questionTitle }}</li>
        <li *ngFor="let choices of questionInfo.choices; let i = index" class="padding-left">
          <div
            [ngClass]="{
              'green-text': questionInfo.choices[i].isCorrect,
              'error-text': !questionInfo.choices[i].isCorrect
            }"
          >
            {{ questionInfo.choices[i].text }}
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div class="table-container">
    <div class="table">
      <div class="table-heading">
        <div class="table-item">{{ 'debates.opinions' | translate }}</div>
        <div class="table-item">{{ 'debates.datetime' | translate }}</div>
        <div class="table-item">{{ 'debates.vote' | translate }}</div>
        <div class="table-item">{{ 'debates.author' | translate }}</div>
      </div>
      <lms-mars1-debate-opinion-row
        *ngFor="let opinion of debate.debate"
        [opinion]="opinion"
      ></lms-mars1-debate-opinion-row>
    </div>
  </div>

  <!-- cancel debate modal -->
  <lms-modal #cancelDebateModal>
    <div class="gl-modal__header">
      <div class="gl-modal__title">
        {{ 'debates.messages.cancelQuestion' | translate }}
      </div>
      <div class="gl-modal__close" (click)="closeCancelDebateModal()">
        <span class="glicon-close"></span>
      </div>
    </div>
    <div>
      <lms-dynamic-form
        #dynamicForm
        [questions]="questions"
        [action]="'debate.detail'"
        [options]="{ submitLabel: 'actions.yes', disableCard: true }"
        (submit)="onSubmit($event)"
      >
        <gl-button
          color-secondary
          [text]="'actions.no' | translate"
          (onClick)="closeCancelDebateModal()"
          form-actions-before
        ></gl-button>
      </lms-dynamic-form>
    </div>
  </lms-modal>
</div>
